/**
 * WebSocket
 */

// const app_ws = process.env.VUE_APP_WS;

class FxWebSocket {
  /**
   * @param {*String} url connection address
   */
  constructor() {
    this.url = process.env.VUE_APP_WS_OPTIONS; // process.env.VUE_APP_WS_OPTIONS; // `ws://192.168.21.136:30222/websocket`;
    this.lockReconnect = false;
    this.maxReconnect = 3;
    this.socket = null;
    this.isWebsock = false;
    this.websocketsendInterval = null;
    this.pongFunc = null;
    this.pongTime = 20 * 1000;
    this.pongBuffer = Buffer.from("ping");
    this.reconnectTime = 6 * 1000;

    this.initWebSocket();
  }

  /**
   * create
   */
  initWebSocket() {
    if ("WebSocket" in window) {
      this.socket = new WebSocket(this.url);

      this.websocketonopen();

      this.websocketonerror();

      // this.websocketonclose();
    } else {
      console.log("Your browser does not support websockets");
    }
  }

  /**
   * closure
   */
  websocketonclose(func) {
    this.socket.onclose = (e) => {
      console.log("socker closed", e);

      // Cancel the heartbeat timing
      clearTimeout(this.pongFunc);

      // this.reconnect();

      func();
    };
  }

  /**
   * 接收
   */
  websocketonmessage(messageCabk) {
    try {
      this.socket.onmessage = (e) => {
        // console.log("messageCabk", e);

        if (e.data) {
          if (JSON.parse(e.data).info === "pong") return;

          messageCabk(JSON.parse(e.data));

          // The message is obtained successfully, reset the heartbeat
          // clearTimeout(this.pongFunc);

          // this.setTimePongSend();
        }
      };
    } catch (error) {
      console.log("WebSocketonmessage error", error);
    }
  }

  /**
   * mistake
   */
  websocketonerror() {
    this.socket.onerror = (e) => {
      console.log(
        "An error occurred with the WebSocket connection",
        e,
        this.socket
      );
    };
  }

  /**
   * Open
   */
  websocketonopen() {
    this.socket.onopen = () => {
      console.log("websocket open success");

      this.isWebsock = true;

      // heartbeat
      this.pongSend();

      if (this.lockReconnect) {
        this.lockReconnect = false;
      }
    };
  }

  /**
   * data sending
   */
  websocketsend(msg) {
    if (this.isWebsock) {
      this.socket.send(JSON.stringify(msg));
    } else {
      // Rotation training to determine whether the reconnection is successful
      setTimeout(() => {
        this.websocketsend(msg);
      });
    }
  }

  setTimePongSend() {
    this.pongFunc = setTimeout(() => {
      this.pongSend();
    }, this.pongTime);
  }

  /**
   * heartbeat
   */
  pongSend() {
    if (this.isWebsock) {
      this.socket.send(this.pongBuffer);

      this.setTimePongSend();
    }
  }

  /**
   * Reconnection
   */
  reconnect() {
    console.log("try to reconnect");

    this.isWebsock = false;

    setTimeout(() => {
      this.lockReconnect = true;
      // Change the socket connection state
      this.initWebSocket();
    }, this.reconnectTime);
  }
}

export default FxWebSocket;
